/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type ConsentDefinition =
  (typeof ConsentDefinition)[keyof typeof ConsentDefinition]

export const ConsentDefinition = {
  MPAN_BILLING: "MPAN_BILLING",
  MPAN_SETTLEMENT: "MPAN_SETTLEMENT",
  MPRN_BILLING: "MPRN_BILLING",
} as const
